import React from "react";

const Filter = ({
  selectedFilter,
  onFilterChange,
  showMyStudentsOnly,
  onToggleMyStudentsOnly,
  startDate,
  setStartDate,
  endDate,
  setEndDate
}) => {
  const handleFilterChange = (event) => {
    const selectedValue = event.target.value;
    onFilterChange(selectedValue);
  };

  const handleToggleMyStudentsOnly = () => {
    onToggleMyStudentsOnly(!showMyStudentsOnly);
  };

  return (
    <div className="flex flex-col justify-center items-center gap-4 mb-4 w-full">
      <select
        id="filter"
        className="text-sm rounded-lg p-2.5 w-full sm:w-1/2
                 bg-zinc-100 text-zinc-900 
                 dark:bg-zinc-900 dark:text-zinc-100
                   outline-none"
        value={selectedFilter}
        onChange={handleFilterChange}
      >
        <option value="date">Filter by day of the week</option>
        <option value="staff">Filter by staff member</option>
        <option value="student">Filter by students</option>
        <option value="name">Filter by type of event</option>
      </select>
      <div className="grid grid-cols-2 w-full sm:w-1/2 gap-4">
        <label htmlFor="date" className="text-lg text-zinc-700 dark:text-zinc-200">
          Start Date
        </label>
        <label htmlFor="date" className="text-lg text-zinc-700 dark:text-zinc-200">
          End Date
        </label>
        <input className="text-sm rounded-lg p-2.5 w-full
                        bg-zinc-100 text-zinc-900
                        dark:bg-zinc-900 dark:text-zinc-100
                          outline-none"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                />
        <input className="text-sm rounded-lg p-2.5 w-full
                        bg-zinc-100 text-zinc-900
                        dark:bg-zinc-900 dark:text-zinc-100
                          outline-none"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                />
      </div>
      <div className="flex flex-row justify-center items-center gap-2">
        <input
          className="w-4 h-4"
          type="checkbox"
          id="myStudentsOnly"
          checked={showMyStudentsOnly}
          onChange={handleToggleMyStudentsOnly}
        />
        <label
          htmlFor="myStudentsOnly"
          className="text-zinc-700 dark:text-zinc-200"
        >
          My Students Only
        </label>
      </div>
    </div>
  );
};

export default Filter;
